module.exports = require('./dist/gatsby-browser');
